import React from 'react'
import EventPopOverCard from './EventPopOver'

const WeekDayEvent = ({ event }) => {
  return (
    <div className="text-left">
      <h6 className="font-weight-bold">{event.title}</h6>
    </div>
  )
}

export const CustomAgendaEvent = ({ event }) => {
  return (
    <>
      <h6>{event.title}</h6>
      <h6>{event.location}</h6>
      <h6>{event.participants}</h6>
      <h6>{event.designation}</h6>
      <h6>{event.pays}</h6>
      <h6>{event.region}</h6>
    </>
  )
}

export const Event = (props) => {
  const event = props.event
  return (
    <EventPopOverCard
      getAllEvents={props.localizer?.messages?.getAllEvents}
      removeEventLocally={props.localizer?.messages?.removeEventLocally}
      textClassName="text-left"
      event_id={event.id}
      id={`event_${event.id}_${event.index}`}
      isOpen={false}
      item={{
        event_name: <WeekDayEvent event={event} />,
        title: event.title,
        start: event.start,
        end: event.end,
        start_date: event.startDate,
        end_date: event.endDate,
        start_time: event.startTime,
        end_time: event.endTime,
        start_date_time: event.start_date_time,
        end_date_time: event.end_date_time,
        isAllDay: event.isAllDay,
        category: event.category,
        type: event.type,
        eventType: event.event_type,
        region: event.region,
        designation: event.designation,
        pays: event.pays,
        participants: event.participants,
        participants_list: event.participants_list,
        reschedule_count: event.reschedule_count, // LAP-770
        // Pièces jointes de l'événement : documents rattachés directement +
        // ceux hérités de la tâche que l'événement planifie.
        documents: event.documents,
      }}
    />
  )
}

export const MonthEvent = (props) => {
  const event = props.event
  return (
    <EventPopOverCard
      getAllEvents={props.localizer?.messages?.getAllEvents}
      removeEventLocally={props.localizer?.messages?.removeEventLocally}
      textClassName="text-left"
      event_id={event.id}
      isOpen={false}
      id={`month_${event.id}_${event.index}`}
      item={{
        event_name: `${event.start} ${event.title}`,
        title: event.title,
        location: event.location,
        start: event.start,
        end: event.end,
        start_date: event.startDate,
        end_date: event.endDate,
        start_time: event.startTime,
        end_time: event.endTime,
        start_date_time: event.start_date_time,
        end_date_time: event.end_date_time,
        isAllDay: event.isAllDay,
        category: event.category,
        type: event.type,
        eventType: event.event_type,
        region: event.region,
        designation: event.designation,
        pays: event.pays,
        participants: event.participants,
        participants_list: event.participants_list,
        reschedule_count: event.reschedule_count, // LAP-770
        // Pièces jointes de l'événement : documents rattachés directement +
        // ceux hérités de la tâche que l'événement planifie.
        documents: event.documents,
      }}
    />
  )
}
